import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/khent-cutout.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import { Globe } from "./Globe";
import { Reveal } from "./Reveal";

const skills = ["Computer Engineer", "Automations Engineer", "Full Stack Developer", "Embedded Systems Builder"];
const rotationDuration = 2000; // Duration for each rotation in milliseconds

export const Banner = () => {
  const [currentSkillIndex, setCurrentSkillIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSkillIndex((prevIndex) => (prevIndex + 1) % skills.length);
    }, rotationDuration);

    return () => clearInterval(interval);
  }, []);

  const handleGmailConnect = () => {
    // Open Gmail with a pre-filled message
    const mailtoLink = "mailto:khentlloyd3@gmail.com?subject=Let’s Connect&body=Hi Khent,";
    window.location.href = mailtoLink;
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <div className="banner-copy">
              <Reveal variant="up">
                <span className="tagline">Cebu City, PH · Cum Laude, B.S. Computer Engineering</span>
              </Reveal>
              <Reveal variant="up" delay={110}>
                <h1>
                  Hi! I'm Khent{" "}
                  <div className="cube-container">
                    <div
                      className="cube"
                      style={{
                        transform: `rotateX(${-currentSkillIndex * 90}deg)`,
                        transition: "transform 1s",
                      }}
                    >
                      {skills.map((skill, index) => (
                        <div
                          key={index}
                          className={`cube-face ${index === currentSkillIndex ? "active" : ""}`}
                          style={{ transform: `rotateX(${index * 90}deg) translateZ(50px)` }}
                        >
                          {skill}
                        </div>
                      ))}
                    </div>
                  </div>
                </h1>
              </Reveal>
              <Reveal variant="up" delay={210}>
                <p>
                  Cum Laude Computer Engineering graduate from Cebu Institute of Technology - University, based in Cebu City. I build secure, scalable applications with JavaScript, React, and Next.js, complemented by hands-on experience in industrial automation, embedded systems, and networking - from PLC/SCADA process control to serverless AWS backends and autonomous robotics. I'm committed to solving real-world problems through clean, innovative code.
                </p>
              </Reveal>
              <Reveal variant="up" delay={310}>
                <div className="banner-cta">
                  <button className="banner-primary-btn" onClick={handleGmailConnect}>
                    Let’s Connect <ArrowRightCircle size={22} />
                  </button>
                  <a href="#experience" className="banner-secondary-btn">
                    View Experience
                  </a>
                </div>
              </Reveal>
            </div>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <Reveal variant="scale" delay={160}>
            <div className="hero-photo">
              <div className="hero-photo-frame">
                <img
                  src={headerImg}
                  alt="Khent Lloyd Cases smiling in graduation regalia, Cum Laude Computer Engineering graduate"
                  width={300}
                  height={287}
                  loading="eager"
                  fetchPriority="high"
                />
              </div>
              <Globe size={200} />
            </div>
            </Reveal>
          </Col>
        </Row>
      </Container>
    </section>
  );
};